export const PAYMENT_PROVIDERS_QUERY_KEY = 'paymentProvidersQueryKey'
